import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsDomainComponent extends Component {
  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='name' />
          </form.fieldset>
        </div>
      </div>
    </Form>
  </template>
}
